import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { ViewService } from "../services/view.service";
import { View } from '../objects/ViewObject';
import { Globals } from '../objects/Globals';
import { MenuService } from "../services/menu.service";
import { WorkspaceService } from '../services/workspace.service';
var ViewComponent = /** @class */ (function () {
    // showSideBar
    function ViewComponent(viewService, globals, view, menuService, workspaceService) {
        var _this = this;
        this.viewService = viewService;
        this.globals = globals;
        this.view = view;
        this.menuService = menuService;
        this.workspaceService = workspaceService;
        this.menuActions = [];
        this.showView = true;
        this.isUserHide = false;
        this.isStandardHide = false;
        this.system = "system";
        this.user = "user";
        this.menu = false;
        this.draggable = true;
        this.hidePanel = false;
        this.profileView = false;
        this.notFixedWidth = false;
        this.viewSelectedChanged = new EventEmitter();
        this.menuSelectedChanged = new EventEmitter();
        this.showSideBar = new EventEmitter();
        this.sub = this.viewService.refreshViewChanged$.subscribe(function (result) {
            if (result) {
                if (_this.groupType) {
                    _this.viewService.createViewList(_this.groupType).subscribe(function (result) {
                        if (result) {
                            _this.componentId = result;
                            _this.getViewList();
                        }
                    });
                }
                else {
                    _this.getViewList();
                }
            }
        });
    }
    Object.defineProperty(ViewComponent.prototype, "setMenuId", {
        set: function (menuId) {
            var _this = this;
            this.menu = true;
            if (menuId) {
                this.menuService.getMenuCardMenuActions(menuId).subscribe(function (result) {
                    _this.menuActions = JSON.parse(result);
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ViewComponent.prototype, "refreshView", {
        set: function (refresh) {
            this.getViewList();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewComponent.prototype, "setComponentId", {
        set: function (id) {
            var _this = this;
            this.componentId = id;
            if (this.componentId) {
                this.previousComponentId = this.componentId;
                this.viewService.getSystemViewList(this.componentId).subscribe(function (result) {
                    _this.systemViewList = _this.sortViewList(JSON.parse(result));
                });
                this.viewService.getUserViewList(this.componentId).subscribe(function (result) {
                    _this.userViewList = _this.sortViewList(JSON.parse(result));
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    // @HostListener('window:resize', ['$event'])
    // onResize(event) {
    //   if (event.target.innerWidth < 992) {
    //     this.showView = false;
    //   }
    //   else{
    //     if (!this.closeBtnClicked){
    //       this.showView = true;
    //     }
    //   }
    // }
    ViewComponent.prototype.getViewList = function () {
        var _this = this;
        if (this.componentId) {
            this.viewService.getSystemViewList(this.componentId).subscribe(function (result) {
                _this.systemViewList = _this.sortViewList(JSON.parse(result));
            });
            this.viewService.getUserViewList(this.componentId).subscribe(function (result) {
                _this.userViewList = _this.sortViewList(JSON.parse(result));
            });
        }
    };
    ViewComponent.prototype.sortViewList = function (list) {
        return list.sort(function (a, b) {
            if (a.ViewOrder > b.ViewOrder) {
                return 1;
            }
            else if (a.ViewOrder < b.ViewOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    ViewComponent.prototype.onClickMenu = function (action) {
        var _this = this;
        this.menuService.selectMenuCardMenuAction(this.menuId, action.ActionName).subscribe(function (result) {
            _this.menuSelectedChanged.emit(result);
        });
    };
    ViewComponent.prototype.SelectedViewChanged = function (event, view) {
        this.viewSelectedChanged.emit(event);
        this.view.currentView = view;
    };
    ViewComponent.prototype.ngOnInit = function () {
        //this.showView = (window.innerWidth) > 992;
        this.getViewList();
    };
    ViewComponent.prototype.ngOnDestroy = function () {
        if (this.sub)
            this.sub.unsubscribe();
    };
    ViewComponent.prototype.ShowToDo = function () {
        this.showView = true;
        this.closeBtnClicked = false;
        this.showSideBar.emit(true);
    };
    ViewComponent.prototype.HideToDo = function () {
        this.showView = false;
        this.closeBtnClicked = true;
        this.showSideBar.emit(false);
    };
    return ViewComponent;
}());
export { ViewComponent };
